import React from 'react';
import { AppBar, Toolbar, Button, Typography, Box, Container, Stack, IconButton, useMediaQuery, useTheme } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { IMAGES, PHONE_DISPLAY, PHONE_HREF } from '../theme';
import { useQuote } from './QuoteDialog';
export function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    openQuote
  } = useQuote();
  return <AppBar position="sticky" color="inherit" elevation={1} sx={{
    py: 1
  }} data-id="element-46">
      <Container maxWidth="lg" data-id="element-47">
        <Toolbar disableGutters sx={{
        justifyContent: 'space-between'
      }} data-id="element-48">
          <Box component="img" src={IMAGES.logo} alt="The Patio Cover Company" sx={{
          height: {
            xs: 56,
            md: 80
          },
          objectFit: 'contain'
        }} data-id="element-49" />

          {!isMobile ? <Stack direction="row" spacing={4} alignItems="center" data-id="element-50">
              <Stack direction="row" spacing={1} alignItems="center" sx={{
            color: 'primary.main'
          }} data-id="element-51">
                <PhoneIcon data-id="element-52" />
                <Typography variant="h6" fontWeight="bold" data-id="element-53">
                  <a href={PHONE_HREF} style={{
                textDecoration: 'none',
                color: 'inherit'
              }} data-id="element-54">
                    {PHONE_DISPLAY}
                  </a>
                </Typography>
              </Stack>
              <Button variant="contained" color="secondary" size="large" onClick={openQuote} data-id="element-55">
                Get a Free Quote
              </Button>
            </Stack> : <Stack direction="row" spacing={1} data-id="element-56">
              <IconButton color="primary" href={PHONE_HREF} data-id="element-57">
                <PhoneIcon data-id="element-58" />
              </IconButton>
              <Button variant="contained" color="secondary" size="small" onClick={openQuote} data-id="element-59">
                Quote
              </Button>
            </Stack>}
        </Toolbar>
      </Container>
    </AppBar>;
}